import type { TextAreaProps } from "@nextui-org/react";
import { cn, Textarea } from "@nextui-org/react";
import React from "react";

export interface SharedPromptInputProps extends TextAreaProps {
  maxLength?: number;
}

const SharedPromptInput = React.forwardRef<HTMLTextAreaElement, SharedPromptInputProps>(
  ({ classNames = {}, maxLength = 2000, placeholder = "Enter a prompt here", ...props }, ref) => {
    return (
      <Textarea
        maxLength={maxLength}
        id="prompt-input"
        ref={ref}
        aria-label="Prompt"
        className="min-h-[40px]"
        classNames={{
          ...classNames,
          label: cn("hidden", classNames?.label),
          input: cn("py-0 text-default-400 text-sm placeholder:text-[#A1A1AA] placeholder:text-sm", classNames?.input),
        }}
        minRows={1}
        placeholder={placeholder}
        radius="lg"
        variant="bordered"
        {...props}
      />
    );
  },
);

export default SharedPromptInput;

SharedPromptInput.displayName = "SharedPromptInput";